<div class="loader2">
  <h1 class="animate2">Se încarcă ...</h1>
</div>